class TriptychHeader {
  constructor() {
    this.$body = $('body')
    this.$triptychHeader = this.$body.find('.triptych-header')
    this.trigger = parseFloat(this.$triptychHeader.data('trigger'))
    this.$slider = this.$body.find('.triptych-slider')
    this.sliderSettings = this.$slider.data('slider-params')
    if (this.$triptychHeader.length) {
      this.initialize();
    }
  }

  initialize() {
    $(window).on('resize', () => {
      this.initSlider()
    })
    this.initSlider()
  }

  initSlider() {
    if ($(window).width() > this.trigger) {
      if (this.$slider.hasClass('slick-initialized')) {
        this.$slider.slick('unslick')
      }
      return;
    }
    if (!this.$slider.hasClass('slick-initialized')) {
      return this.$slider.slick(this.sliderSettings)
    }
  }
}

export default TriptychHeader



// WEBPACK FOOTER //
// ./scripts/components/TriptychHeader.js